import React from "react"
import ReportToolsIconButton from "./ReportToolsIconButton"

const ReportToolsDownloadDataIconButton = ({ title = "Download data", size = "small", ...props }) => (
  <ReportToolsIconButton title={title} size={size} icon="download" {...props} />
)

export default ReportToolsDownloadDataIconButton
